<template>
  <div class="setting-new-password">
    <div class="form-group">
      <input
        v-if="!isShowPwd1"
        type="password"
        name="password"
        :placeholder="placeholderGroup.setPassWord"
        v-model.trim="form.password"
        v-validate="'required|min:6|max:20'"
        @blur="showError.password = true"
        :class="{'danger-border': errors.has('password') && showError.password}"
        autocomplete="new-password"
      />
      <input
        v-if="isShowPwd1"
        type="text"
        name="password"
        :placeholder="placeholderGroup.setPassWord"
        v-model.trim="form.password"
        v-validate="'required|min:6|max:20'"
        @blur="showError.password = true"
        :class="{'danger-border': errors.has('password') && showError.password}"
        autocomplete="new-password"
      />
      <span class="show-pwd" @click="showPwd('isShowPwd1')">
        <svg class="icon">
          <use xlink:href="#icon-eye" v-show="isShowPwd1" />
          <use xlink:href="#icon-eye_off" v-show="!isShowPwd1" />
        </svg>
      </span>
      <p class="error-info">
        <span v-show="showError.password">{{ errors.first('password') }}</span>
      </p>
    </div>

    <div class="form-group">
      <span class="show-pwd" @click="showPwd('isShowPwd2')">
        <svg class="icon">
          <use xlink:href="#icon-eye" v-show="isShowPwd2" />
          <use xlink:href="#icon-eye_off" v-show="!isShowPwd2" />
        </svg>
      </span>
      <input autocomplete="off"
        v-if="isShowPwd2"
        type="text"
        name="confirmPassword"
        :placeholder="placeholderGroup.confirmPassword"
        v-model.trim="form.confirmPassword"
        v-validate="'required|min:6|max:20'"
        @keyup.enter="settingNewPassword"
        @focus="confirmErrorMsg = ''"
        @blur="confirmPassword"
        :class="{'danger-border': errors.has('confirm') && showError.confirmPassword}"
      />
      <input autocomplete="off"
        v-if="!isShowPwd2"
        type="password"
        name="confirmPassword"
        :placeholder="placeholderGroup.confirmPassword"
        v-model.trim="form.confirmPassword"
        v-validate="'required|min:6|max:20'"
        @keyup.enter="settingNewPassword"
        @focus="confirmErrorMsg = ''"
        @blur="confirmPassword"
        :class="{'danger-border': errors.has('confirm') && showError.confirmPassword}"
      />
      <p class="error-info">
        <span v-show="showError.confirmPassword">{{ confirmErrorMsg || errors.first('confirm') }}</span>
      </p>
      <p class="error-info" v-if="errorMessagePrompt">
        <span>{{ errorMessagePrompt }}</span>
      </p>
    </div>

    <div class="form-group">
      <button class="form-submit line-button" @click="settingNewPassword" v-show="!isLoading">{{ $t('submit') }}</button>
      <spinner :show="isLoading" class="spinner-component"></spinner>
    </div>
  </div>
</template>

<script>
import Spinner from '../../../components/Spinner.vue';
import locales from './lang';
import { SET_USER_INFO } from '../../../store/mutation-types';
export default {
  name: 'setting-new-password-view',
  components: {
    Spinner
  },
  data: function () {
    return {
      isLoading: false,
      isShowPwd1: false,
      isShowPwd2: false,
      placeholderGroup: {
        setPassWord: this.$t('setPassWord'),
        confirmPassword: this.$t('confirmPassword')
      },
      form: {
        password: '',
        confirmPassword: ''
      },
      showError: {
        password: false,
        confirmPassword: false
      },
      errorMessagePrompt: '',
      networkError: this.$t('networkError'),
      setPasswordSuccess: this.$t('setPasswordSuccess'),
      confirmErrorMsg: ''
    };
  },
  locales,
  watch: {
    'form.password': {
      handler() {
        this.showError.password = false;
      },
      deep: true
    },
    'form.confirmPassword': {
      handler() {
        this.showError.confirmPassword = false;
      },
      deep: true
    }
  },
  methods: {
    showPwd: function (item) {
      this[item] = !this[item];
    },
    confirmPassword: function () {
      this.showError.confirmPassword = true;
      this.confirmErrorMsg = '';
      if (this.form.password !== this.form.confirmPassword) {
        this.confirmErrorMsg = this.$t('confirmErrorMsg');
        return false;
      }
      return true;
    },
    settingNewPassword: function () {
      for (let i in this.showError) {
        this.showError[i] = true;
      }
      if (!this.confirmPassword()) return;
      this.$validator.validateAll().then(success => {
        if (!success) {
          return;
        }
        this.isLoading = true;
        this.errorMessagePrompt = '';
        new Promise((resolve, reject) => {
          this.$http
            .patch('api/password/set', {
              password: this.form.password
            })
            .then(
              response => {
                this.isLoading = false;
                if (response.data.code === 0) {
                  this.isLoading = true;
                  this.errorMessagePrompt = '';
                  resolve(response.data.code);
                } else {
                  this.errorMessagePrompt = response.data.message;
                }
              },
              response => {
                this.errorMessagePrompt = this.networkError;
                this.isLoading = false;
              }
            );
        }).then(code => {
          if (code === 0) {
            this.isLoading = true;
            this.$emit('settingNewPassword', this.setPasswordSuccess);
            this.$http
              .post('api/phone-login', {
                calling_code: this.$store.state.user['calling_code'],
                phone_num: this.$store.state.user['phone_num'],
                password: this.form.password
              })
              .then(
                response => {
                  this.isLoading = false;
                  if (response.data.code === 0) {
                    window.localStorage.setItem('token', response.data.data.access_token);
                    this.$store.commit(SET_USER_INFO, response.data.data);
                    this.$router.push('/modify');
                  }
                },
                response => {
                  this.isLoading = false;
                }
              );
          }
        });
      });
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import '../../../assets/scss/variables';
@import '../../../assets/scss/formstyle';
</style>



// WEBPACK FOOTER //
// SetNewPassword.vue?09c35216